window.addEventListener('load', function() {
  const allHrefs = document.querySelectorAll('.boost-pfs-filter-product-item-image-link')
  allHrefs.forEach((href, index) => {
    const hrefAttribute = href.getAttribute("href").split('/').pop()
    fetch(`/products/${hrefAttribute}.js`)
    .then(response => response.text())
    .then(data => {
      const product = JSON.parse(data)
      if(product.variants.length === 1) {
        const productID = product.id
        const wrapper = document.querySelector(`[data-id="${productID}"]`)
        const atcButton = 
        `<form method="post" action="/cart/add">
          <input type="hidden" name="id" value="${product.variants[0].id}" />
          <input type="hidden" min="1" type="number" id="quantity" name="quantity" value="1"/>
          
          <div class="boost-pfs-quickview-btn boost-pfs-filter-button boost-pfs-cart-button" data-variant-id="${product.variants[0].id}"id="btn-AddToCartForm-${productID}">
              <span>Add to cart</span>
          </div>
        </form>`
        wrapper.querySelector('.boost-pfs-action-list-wrapper').innerHTML = atcButton
      }
    }) 
  })

  const checkLoadedButtonATC = setInterval(function() {
    if (document.querySelectorAll('[id*="btn-AddToCartForm"]').length !== 0) {
      clearInterval(checkLoadedButtonATC);
      document.querySelectorAll('[id*="btn-AddToCartForm"]').forEach(trigger => {
        trigger.addEventListener("click", function(e) {
          e.preventDefault();
          e.stopPropagation();

          var productId = this.getAttribute("data-variant-id");

          var lineItem = {
            id: productId,
            quantity: 1
          };

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(lineItem)
          }).then(response => response.json()).then(data => {
            console.log({data})
            new theme.CartDrawer();
            document.querySelector('a[href="/cart"]').click()
          }).catch(error => {
            console.error('Error:', error);
          });
        });
      })

    }
  }, 700);

  checkLoadedButtonATC();

})

